import React from "react";

type InfoCardVariant = "info" | "success" | "warning" | "error";

interface InfoCardProps {
  variant?: InfoCardVariant;
  icon?: React.ReactNode;
  title?: string;
  children: React.ReactNode;
  className?: string;
}

const variantStyles: Record<
  InfoCardVariant,
  { container: string; title: string; text: string }
> = {
  info: {
    container: "bg-electrum-50 border-electrum-200",
    title: "text-electrum-400",
    text: "text-electrum",
  },
  success: {
    container: "bg-green-50 border-green-200",
    title: "text-green-800",
    text: "text-green-700",
  },
  warning: {
    container: "bg-yellow-50 border-yellow-200",
    title: "text-yellow-800",
    text: "text-yellow-700",
  },
  error: {
    container: "bg-red-50 border-red-200",
    title: "text-red-800",
    text: "text-red-700",
  },
};

const InfoCard: React.FC<InfoCardProps> = ({
  variant = "info",
  icon,
  title,
  children,
  className = "",
}) => {
  const styles = variantStyles[variant];

  return (
    <div
      className={`p-4 ${styles.container} border rounded-md ${className}`}
      role="alert"
    >
      {(icon || title) && (
        <div className="flex items-center gap-2 mb-2">
          {icon && <div className="flex-shrink-0">{icon}</div>}
          {title && (
            <p className={`text-sm ${styles.title} font-medium`}>{title}</p>
          )}
        </div>
      )}
      <div className={`text-xs ${styles.text}`}>{children}</div>
    </div>
  );
};

export default InfoCard;
